import React, { useEffect,useState} from 'react';
import './Footer.css';
import FullLogo from '../assets/img/vit full logo.png'
import {
    getFirestore,doc, setDoc
} from "firebase/firestore";
import uuid from 'react-uuid'
function Footer(){
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const getName = (e) => {
        setName(e.target.value);
    }
    const getEmail = (e) => {
        setEmail(e.target.value);
    }
    const sentNewsUpdate=(e)=>{
        e.preventDefault();
        const db=getFirestore();
        const uid = uuid();
        const NLData={
            Name:name,
            Uid:uid,
            Email:email
        }   
        console.log(NLData);
        setDoc(doc(db,"NewsLetter",uid),NLData);
        setName("");
        setEmail("");
        alert("News Letter Updated successfully");
    }
    return (
        <React.Fragment>
            <div className="container news-letter">
                <div className="news-left">
                    <p>KEEP ME UPDATED</p>
                </div>
                <div className="news-right">
                    <form id="newsletter">
                        <input type="text" name="name" id="names" placeholder="Name *" required onChange={getName} value={name}/>
                        <input type="email" name="email" id="emails" placeholder="Email *" required onChange={getEmail} value={email}/>
                        <input type="submit" value="Submit" className="submit" onClick={sentNewsUpdate}/>
                    </form>
                </div>
            </div>
            <footer>
                <div className="image">
                    <img src={FullLogo} alt="Vit ap Full logo"/>
                </div>
                <div className="footer-info">
                    <p>Apply Knowledge. Improve Life</p>
                    <p>All rights reserved. 2021. VIT AP UNIVERSITY</p>
                </div> 
            </footer>
        </React.Fragment>
    );
}
export default Footer;